import axios from 'axios';
import router from '@/router';
import { Message } from 'element-ui';

const API = {
    REST: {
        ADMIN: "/admin",
        RESALE: "/resale",
        COIN: "/coin",
        CUSTOMER: "/customer",
        GRADE: "/grade",
        PRODUCT: "/product",
        CATEGORY: "/category",
        ADDRESS: "/address",
        PERMISSION: "/permission",
        LOG: "/log",
        LOGMEMO: "/logmemo",
        LOCK: "/lock",
        OUT: "/out",
        NOTIFY: "/notify",
        SEND: "/send",
        DOWNLOAD: "/download",
        BUYER: "/buyer"
    },
    ALL: {
        ADDRESS: "/address/all",
        ADMIN: "/admin/all",
        CATEGORY: "/category/all",
        CUSTOMER: "/customer/all",
        GRADE: "/grade/all",
        RESALE: "/resale/all",
        PERMISSION: "/permission/all",
        LOG: "/log/all",
    },
    PUBLIC: {
        LOGIN: "/public/login",
        VERIFY: "/public/verify",
        INDEX: "/index",
        UPLOAD: "/upload",
        PASSWORD_UPDATE: "/passwordUpdate"
    },
    PRODUCT: {
        SCHEDULE: "/product/schedule",
        UNREAD: "/product/unRead",
    },
    NOTIFY: {
        COUNT: "/notify/count",
    },
    ADDRESS: {
        CATEGORY: "/address/listByCategory",
        CUSTOMER: "/address/listByCustomer",
        GRADE: "/address/listByGrade",
    },
    TREE: {
        CATEGORY: "/category/tree"
    },
    INVENTORY: {
        CLEAR: "/inventory/clear",
        INSERT: "/inventory",
        DELETE: "/inventory",
        GET_COUNT0: "/inventory/count0",
        GET_COUNT1: "/inventory/count1",
        GET_COUNT2: "/inventory/count2",
        GET_RECORDS0: "/inventory/records0",
        GET_RECORDS1: "/inventory/records1",
        GET_RECORDS2: "/inventory/records2",
        EXPORT: "/public/inventory/export"
    },
    SETTING: {
        EXPORT4IMAGES: "/setting/export4ImagesFromStock"
    },
    SALE_ADMINS: "/admin/saleAdmins",
    ADMIN_SUPER: "/admin/super",
    ADMIN_UPDATE_LASTDATE: "/admin/updateLastDate",
    DELETE_RESALE_BY_SALERID: "/resale/deleteBySalerId",
    CATEGORY_READ: "/categoryread/read",
    ADMIN_INFO: "/admin/info"
}

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 请求的基础路径，可根据实际情况修改
    timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 添加登录Token
        if (localStorage.getItem("AUTH-ADMIN")) {
			config.headers["AUTH-ADMIN"] = localStorage.getItem("AUTH-ADMIN");
		}
        return config;
    },
    error => {
        // 处理请求错误
        console.log(error); 
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        // 根据实际业务需求处理响应数据
        return res;
    },
    error => {
        if (error.status == 401) {
            // Message.error("尚未登录！");
            router.push("/login");
        }
        else if (error.status == 500) {
            Message.error("服务端出错！");
        }
    }
);

service.defaults.withCredentials = true;

async function doGet(url, params = {}) {
    return service.get(url, { params });
}

async function doPost(url, params = {}) {
    return service.post(url, params);
}

async function doPut(url, params = {}) {
    return service.put(url, params);
}

async function doPatch(url, params = {}) {
    return service.patch(url, params);
}

async function doDelete(url, id) {
    return service.delete(url + '/' + id);
}

// async function doExport(url, params = {}) {
//     return service.get(url, { 
//         params, 
//         responseType: 'blob',
//         headers: {
//             'Content-Type': 'application/json'
//           } 
//     });
// }

export {
    API,
    doGet,
    doPost,
    doPut,
    doPatch,
    doDelete
}